import React from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"

import Button from "../Button/Button"
import { navigate } from "gatsby"

import SubjectIcon from "@material-ui/icons/Subject"
import "./palyazat.scss"

const Palyazat = (props) => {
  const uri = props.uri.split("/")

  const {
    set_metadata,
    text_header_title,
    text_header_description,
    asset_header_picture,
    asset_logo,
    text_title,
    wysiwyg_short_description,
    wysiwyg_description,
    text_palyazat_title,
    arr_palyazat_cards,
  } = props.pageContext.content.services_trainings

  const siteMetadata = {
    title: set_metadata.text_page_title,
    description: set_metadata.text_page_description,
    meta: [
      {
        name: "keywords",
        content: set_metadata.text_keywords,
      },
    ],
    author: `prodHost`,
  }

  return (
    <div className="palyazat-wrapper">
      <LayoutHeaderMenu
        siteMetadata={siteMetadata}
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={text_header_title}
        header_description={text_header_description}
        header_background={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_header_picture.path}`}
        header_shaded
        menu={props.pageContext.menu.entries}
        selected={`${uri[1]}`}
        selected2={`${uri[1]}_${uri[2]}`}
        expanded
        footer={props.pageContext.content.global_values.set_footer}
      >
        <div className="layout-industries-head">
          <div className="image-wrapper">
            <img
              src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_logo.path}`}
              alt=""
            />
          </div>
          <div className="layout-industries-title">
            <h1>{text_title}</h1>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: wysiwyg_short_description }}
            ></div>
          </div>
        </div>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: wysiwyg_description }}
        ></div>
        <h2>{text_palyazat_title}</h2>
        <div className="external-consulting-description">
          {arr_palyazat_cards.map((card, index) => {
            return (
              <div
                className="consultant-card"
                id={card.value.text_palyazat_number}
                key={index}
              >
                {card.value.asset_palyazat_icon ? (
                  <img
                    className="icon"
                    src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${card.value.asset_palyazat_icon.path}`}
                    alt="palyazat_picture"
                  />
                ) : (
                  <SubjectIcon className="icon subject" />
                )}
                <div>
                  <h3>{card.value.text_palyazat_name}</h3>
                  <p className="consultant_person_title">
                    {card.value.text_palyazat_number}
                  </p>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: card.value.wysiwyg_palyazat_short_description,
                    }}
                  ></div>
                </div>
                <div className="button-wrapper">
                  <Button
                    text={"Érdekel"}
                    type={"primary"}
                    model={"2"}
                    onClick={() => {
                      navigate(
                        `/services/palyazat/${card.value.text_palyazat_number}`
                      )
                    }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </LayoutHeaderMenu>
    </div>
  )
}

export default Palyazat
